package com.jingfangpai.common.data.response

import com.jingfangpai.common.constant.Error
import kotlinx.serialization.*

@Serializable(with = ApiResponseSerializer::class)
class ApiResponse<T> (){
    constructor(data: T? = null, error: Error, message:String?):this(){
        this.data = data
        this.error = error
        this.message = message
    }
    var data: T? = null
    open var error: Error = Error.NA
    var message:String? = null
    fun ok():Boolean{
       return Error.NA.equals(error)
    }
    /*companion object {
        fun <T:Any> serializer() : KSerializer<ApiResponse<T>> {
            return ApiResponseSerializer<T>()
        }
    }*/

}

